import { Building2, Package, Users, Settings, Bell, LogOut, FileText, Menu as MenuIcon, ClipboardList } from "lucide-react";

const NavItem = ({ icon: Icon, label, active, onClick, badge, testId }) => (
  <button onClick={onClick} data-testid={testId}
    className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-all relative group
      ${active
        ? "bg-white text-gray-900 shadow-sm font-semibold"
        : "text-gray-500 hover:bg-gray-100 hover:text-gray-700"
      }`}>
    <Icon className={`h-[18px] w-[18px] flex-shrink-0 ${active ? "text-indigo-600" : "text-gray-400 group-hover:text-gray-600"}`} />
    <span className="flex-1 text-left">{label}</span>
    {badge}
  </button>
);

const ABBONAMENTI_PAGES = ["societies", "analytics", "trial"];
const PACCHETTI_PAGES   = ["packages", "prezzi"];
const VENDITORI_PAGES   = ["venditori", "report-provvigioni", "materiali-vendita"];
const IMPOSTAZIONI_PAGES = ["impostazioni", "security", "security-audit", "backup", "demo", "email-diagnostic", "recovery-turni", "telegram-central", "stripe-diagnostic"];

const SidebarContent = ({ activePage, onNavigate, onLogout, user, messaggiBadge, onClose }) => (
  <>
    <div className="px-4 py-5 border-b border-gray-100">
      <div className="flex items-center gap-2.5">
        <img src="/yollo-logo.png" alt="Yollo" className="w-8 h-8 rounded-lg object-contain" />
        <div className="min-w-0">
          <h1 className="text-sm font-bold text-gray-900 truncate">Yollo Admin</h1>
          <p className="text-[11px] text-gray-400 truncate">{user?.nome || user?.email}</p>
        </div>
      </div>
    </div>
    <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
      <NavItem icon={Building2} label="Abbonamenti"
        active={ABBONAMENTI_PAGES.includes(activePage)}
        onClick={() => { onNavigate("societies"); onClose?.(); }} testId="nav-societies" />
      <NavItem icon={Package} label="Pacchetti"
        active={PACCHETTI_PAGES.includes(activePage)}
        onClick={() => { onNavigate("packages"); onClose?.(); }} testId="nav-packages" />
      <NavItem icon={Users} label="Account e società" active={activePage === "company-accounts"}
        onClick={() => { onNavigate("company-accounts"); onClose?.(); }} testId="nav-company-accounts" />
      <NavItem icon={Users} label="Venditori"
        active={VENDITORI_PAGES.includes(activePage)}
        onClick={() => { onNavigate("venditori"); onClose?.(); }} testId="nav-venditori" />
      <NavItem icon={FileText} label="Contrattualistica"
        active={activePage === "contrattualistica"}
        onClick={() => { onNavigate("contrattualistica"); onClose?.(); }} testId="nav-contrattualistica" />
      <NavItem icon={ClipboardList} label="Log Registrazioni"
        active={activePage === "registrazioni-log"}
        onClick={() => { onNavigate("registrazioni-log"); onClose?.(); }} testId="nav-registrazioni-log" />
      <div className="pt-2 mt-2 border-t border-gray-100">
        <NavItem icon={Bell} label="Messaggi"
          active={activePage === "messaggi"}
          onClick={() => { onNavigate("messaggi"); onClose?.(); }} testId="nav-messaggi"
          badge={messaggiBadge > 0 ? (
            <span className="w-5 h-5 bg-red-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center animate-pulse">{messaggiBadge}</span>
          ) : null} />
      </div>
      <NavItem icon={Settings} label="Impostazioni"
        active={IMPOSTAZIONI_PAGES.includes(activePage)}
        onClick={() => { onNavigate("impostazioni"); onClose?.(); }} testId="nav-impostazioni" />
    </nav>
    <div className="px-3 py-3 border-t border-gray-100">
      <button onClick={onLogout} className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium text-gray-400 hover:text-red-500 hover:bg-red-50 transition-all" data-testid="logout-btn">
        <LogOut className="h-[18px] w-[18px]" />
        <span>Esci</span>
      </button>
    </div>
  </>
);

const SuperAdminSidebar = ({ activePage, onNavigate, onLogout, user, messaggiBadge, isOpen, onClose }) => (
  <>
    {/* Desktop sidebar — sempre visibile, in flow */}
    <aside className="hidden md:flex w-[240px] flex-shrink-0 bg-white border-r border-gray-200 flex-col h-screen sticky top-0" data-testid="sidebar">
      <SidebarContent activePage={activePage} onNavigate={onNavigate} onLogout={onLogout} user={user} messaggiBadge={messaggiBadge} />
    </aside>

    {/* Mobile sidebar — overlay su richiesta */}
    {isOpen && (
      <div className="md:hidden fixed inset-0 z-40" onClick={onClose} style={{ background: "rgba(0,0,0,0.35)" }} />
    )}
    <aside className={`md:hidden fixed top-0 left-0 h-screen z-50 w-[240px] bg-white border-r border-gray-200 flex flex-col transition-transform duration-300 ease-in-out ${isOpen ? "translate-x-0" : "-translate-x-full"}`} data-testid="sidebar-mobile">
      <SidebarContent activePage={activePage} onNavigate={onNavigate} onLogout={onLogout} user={user} messaggiBadge={messaggiBadge} onClose={onClose} />
    </aside>
  </>
);

export { NavItem };
export default SuperAdminSidebar;
